import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext, getIn } from 'formik';

import Field from 'core/components/form/form.v2';
import Divider from 'core/components/divider';
import Label from 'core/components/label/label';

import useStyles from './exclusions.styles';

const StormDamageExclusionSection = ({ fieldName, disabled }) => {
  const classes = useStyles();
  const { values } = useFormikContext();

  const stormDamageExclusion = getIn(values, `${fieldName}.stormDamageExclusion`);

  return (
    <Grid item xs={12}>
      <div className={classes.container}>
        <Grid container>
          <Field
            xs={12}
            type="switch"
            id={`${fieldName}.stormDamageExclusion`}
            name={`${fieldName}.stormDamageExclusion`}
            mode="dark"
            label="Storm damage exclusion"
            disabled={disabled}
          />
        </Grid>
        {stormDamageExclusion && (
          <>
            <Divider className={classes.divider} />
            <Label className={classes.label}>Storm damage exclusion</Label>
            <Grid container spacing={2}>
              <Field
                xs={12}
                type="textarea"
                id={`${fieldName}.stormDamageExclusionDetails`}
                name={`${fieldName}.stormDamageExclusionDetails`}
                mode="dark"
                label="Description of reason for excluding the selected items (required)"
                rows={3}
                disabled={disabled}
              />
            </Grid>
          </>
        )}
      </div>
    </Grid>
  );
};

StormDamageExclusionSection.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

StormDamageExclusionSection.defaultProps = {
  disabled: false
};

export default observer(StormDamageExclusionSection);
